import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import { Form, Button, Col, Row, Breadcrumb } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateTimeToText } from "components/MyControl";
import Swal from "sweetalert2";

export default function MenuAdminDetail() {
    const nav = useNavigate();
    const api = new ApiConection();
    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [createMode,setCreateMode] = useState(false);
    const [initialData, setInitialData] = useState({});
    const [simulate, setSimulate] = useState({});
    const [usersGroup, setUserGroup] = useState([]);
    const [menuMaster, setMenuMaster] = useState([]);
    const [menuAuthen, setMenuAuthen] = useState([]);
    const urlPathName = window.location.pathname;


    const getData = async () => {
        const response = await api.getData(`api/UsersAdmin/${id}`);
        //console.log("response", response)
        if (response.status === true) {
            setSimulate(response.data);
            setInitialData(response.data);
        }
    }

    const getUserGroup = async () => {
        const response = await api.getData(`api/UsersGroup/admin`);
        if (response.status === true) {
            setUserGroup(response.data)
        }
    }

    const getMenu = async () => {
        const response = await api.getData(`api/Menu/admin`);
        if (response.status === true) {
            setMenuMaster(response.data)
        }
       
    }
    const getMenuAuthenData = async () => {
        const response = await api.getData(`api/UsersGroup/${simulate?.user_group_id}`);
        //console.log("usergroup", response)
        if (response.status === true) {
            setMenuAuthen(response.data);
        }
    }

    useEffect(() => {
        if (urlPathName === (process.env.PUBLIC_URL+'/menuadmin/create')){
            setMode('edit');
            setCreateMode(true);
        }
    },[urlPathName])

    useEffect(() => {
        
        getUserGroup();
        getData();
    }, [])

    useEffect(()=>{
        getMenuAuthenData();
        getMenu();
        
    },[simulate?.user_group_id])

    const handleSetSimulate = async (event) => {
        const { name, value, checked, type } = event.target;
            if(type === 'checkbox'){
                setSimulate(preData => { return { ...preData, [name]: checked } });
            }else{
                setSimulate(preData => { return { ...preData, [name]: value } });
            }
     }

    const handleBreadcrumbClick = (e) => {
        nav('/menuadmin');
    };
    
    const handleCancel = (event) => {
        if (createMode) {
            nav('/menuadmin'); 
        } else {
            setSimulate(initialData);
            setMode('view');
        }
    }
    

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        let data = {
            login_name: simulate.login_name,
            first_name: simulate.first_name,
            last_name: simulate.last_name,
            show_name: simulate.show_name,
            email: simulate.email,
            tel: simulate.tel,
            active: simulate.active,
            is_approved: true,
            user_group_id: simulate.user_group_id
        }

        if(createMode === true){
            data.password = simulate.password;
            // data.user_group_id = 1;
        }

        if (urlPathName === (process.env.PUBLIC_URL+'/menuadmin/create')){
            const response = await api.postData(`api/UsersAdmin`, data)
            if (response.status === true) {
                nav('/menuadmin');
            } else{
                setAlert(response.message);
            }
        } else {
            const response = await api.putData(`api/UsersAdmin/${id}`, data);

            if (response.status === true) {
                Swal.fire({title:'บันทึกสำเร็จ', icon:'success',heightAuto: false});
                await getData();
                setMode('view');
            } else {
                Swal.fire({title:'บันทึกไม่สำเร็จ', icon:'error',heightAuto: false});
                setAlert(response.message);
                setMode('edit');
            }
        }

        setLoading(false);
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'ต้องการลบข้อมูลผู้ใช้ ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#727a82',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ตกลง',
            heightAuto: false
          }).then((result) => {
            if (result.isConfirmed) {
                api.deleteData(`api/UsersAdmin/${id}`)
                .then((response) => {
                    if (response.status === true) {
                        Swal.fire({title:'ลบสำเร็จ', icon:'success',heightAuto: false});
                        nav('/menuadmin');
                    } else {
                        Swal.fire({title:'เกิดข้อผิดพลาด', icon:'error',heightAuto: false});
                    }
                })
            }
        })
    }

    return (
        <Layout4Admin1>
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>จัดการผู้ใช้สำหรับผู้ดูแล</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {
                                mode === 'view' ? 'ข้อมูลผู้ใช้' :
                                createMode === true ? 'สร้างบัญชีผู้ใช้' :
                                'แก้ไขข้อมูลผู้ใช้'
                            }
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            {
                                                mode === 'view' ? 'ข้อมูลผู้ใช้' :
                                                createMode === true ? 'สร้างบัญชีผู้ใช้' :
                                                'แก้ไขข้อมูลผู้ใช้'
                                            }
                                        </h5>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                    
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className='me-3'>
                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">ชื่อบัญชี</Form.Label>
                                                <Form.Label>{simulate?.login_name}&nbsp;</Form.Label>
                                            </Form.Group>
                                        }

                                        {
                                            createMode === true &&
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ชื่อบัญชี</Form.Label>
                                                <Form.Control type={'text'}
                                                    className=''
                                                    name={'login_name'}
                                                    value={simulate?.login_name}
                                                    onChange={handleSetSimulate}
                                                    placeholder="ชื่อบัญชี" 
                                                    required={true} />
                                            </Form.Group>
                                        }

                                        {

                                            createMode === true &&
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>รหัสผ่าน</Form.Label>
                                                <Form.Control type={'password'}
                                                    className=''
                                                    name={'password'}
                                                    value={simulate?.password}
                                                    onChange={handleSetSimulate}
                                                    placeholder="รหัสผ่าน" 
                                                    required={true} />
                                            </Form.Group>
                                        }
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ชื่อ</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'first_name'}
                                                value={simulate?.first_name}
                                                onChange={handleSetSimulate}
                                                placeholder="ชื่อ" 
                                                required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>นามสกุล</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'last_name'}
                                                value={simulate?.last_name}
                                                onChange={handleSetSimulate}
                                                placeholder="นามสกุล" 
                                                required={true} />
                                        </Form.Group>
                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">ชื่อที่แสดง</Form.Label>
                                                <Form.Label>{simulate?.show_name}&nbsp;</Form.Label>
                                            </Form.Group>
                                        }
                                        
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>อีเมล</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'email'}
                                                value={simulate?.email}
                                                onChange={handleSetSimulate}
                                                placeholder="อีเมล" 
                                                required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>เบอร์โทรศัพท์</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'tel'}
                                                value={simulate?.tel}
                                                onChange={handleSetSimulate}
                                                placeholder="เบอร์โทรศัพท์"
                                                required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                                <Form.Label className='label-title'>สิทธิ์ผู้ใช้</Form.Label>
                                                {
                                                mode === 'view' &&
                                                <Form.Label className='d-block pt-2 pb-1 '>{usersGroup?.find( x => x.id === simulate?.user_group_id )?.name}</Form.Label>
                                                }
                                                {
                                                mode === 'edit' &&
                                                <Form.Select name={'user_group_id'}
                                                    value={simulate?.user_group_id}
                                                    required={true}
                                                    onChange={handleSetSimulate} >
                                                    <option value=''>--เลือกสิทธิ์ผู้ใช้--</option>
                                                    {usersGroup
                                                    .map((group,index) => (
                                                    <option key={index} value={group.id}>
                                                        {group.name}
                                                    </option>
                                                    ))}
                                                </Form.Select>
                                                 }
                                        </Form.Group>
                                        {simulate?.user_group_id && (
                                            <Form.Group as={Row} className='mb-3'>
                                            <Form.Label className='label-title'>เมนูที่เข้าถึงได้</Form.Label>
                                                {
                                                    menuMaster.map((obj,index)=>(
                                                        <div key={index} className={(obj.parent_id !== null)? 'mb-2 ms-4' : 'mb-2'}>
                                                            <Form.Check 
                                                            name={`chk_menu_${obj.id}`}
                                                            id={`chk_menu_${obj.id}`} 
                                                            label={obj.name} 
                                                            value={obj.id}
                                                            checked={menuAuthen.arr_menu?.find(x => parseInt(x.id)  === parseInt(obj.id) ) !== undefined}
                                                            onChange={undefined} 
                                                            disabled={true} />
                                                        </div>
                                                    ))}   
                                            </Form.Group>
                                        )}
                                        
                                    </Col>
                                    <Col className="me-3">
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่สร้าง</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.create_date)}</Form.Label>
                                        </Form.Group>

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">วันที่แก้ไขล่าสุด</Form.Label>
                                                <Form.Label>{ConvertDateTimeToText(simulate?.modify_date)}</Form.Label>
                                            </Form.Group>
                                            
                                        }

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">แก้ไขโดย</Form.Label>
                                                <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                            </Form.Group>
                                        }
                                        
                                    <Form.Group className='mb-3'>
                                        <Form.Label className='label-title'>Active</Form.Label>
                                        <Form.Check type={'switch'}
                                            id={'active'}
                                            name={'active'}
                                            disabled={(mode === 'view') ? true : false}
                                            onChange={event => handleSetSimulate(event)}
                                            checked={simulate?.active}
                                            label={(simulate?.active == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                        />
                                    </Form.Group>
                                    {/* <Form.Group className='mb-3'>
                                        <Form.Label className='label-title'>Approved</Form.Label>
                                        <Form.Check type={'switch'}
                                            id={'is_approved'}
                                            name={'is_approved'}
                                            disabled={(mode === 'view') ? true : false}
                                            onChange={event => handleSetSimulate(event)}
                                            checked={simulate?.is_approved}
                                            label={(simulate?.is_approved == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                        />
                                    </Form.Group> */}
                                    </Col>
                                </Row>
                            </div>

                            <Col className='text-end'>
                                {
                                    mode === 'view' &&
                                    <Button variant="outline-danger" type="button" className=''
                                        onClick={event => handleDelete(id)}>
                                        ลบ
                                        <i className="ms-2 fa-solid fa-trash"></i>
                                    </Button>
                                }
                            </Col>

                            {
                                alert != '' &&
                                <div className="alert alert-danger" role="alert">
                                    {alert}
                                </div>
                            }

                            {
                            <Row>
                                <Col>
                                    {createMode && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                สร้าง
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                    {!createMode && mode === 'edit' && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                บันทึก
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>
                            }
                        </div>
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    )
}